import { withLoader } from 'util/routeHelper';

export default store => ({
	path: 'terms',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'terms',
				),
			store,
			'TERMS',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Terms/index.js